/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
var $ = require('jquery');

window.FontAwesomeConfig = {
    // autoReplaceSvg: false,
    searchPseudoElements: true
};

window.utf8Decode = function(s) {
  return decodeURIComponent(escape(s));
}

// Cookies (Use in rgpd, ...)
window.getCookie = function(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));

    return match && match.length ? match[2] : null;
}
window.setCookie = function(name, value, expires) {
    // document.cookie = 'rgpd=approved; expires=Fri, 3 Aug 2020 20:47:11 UTC; path=/';
    var d = new Date();
    d = new Date((d.getTime() + 1000) * expires);
    document.cookie = name + '=' + value + '; expires=' + d.toGMTString() + '; path=/;SameSite=Lax;';
}

// Common

window.now = (() => {
    var d = new Date();
    var year = d.getFullYear();
    var month = ('0' + (d.getMonth() + 1)).slice(-2);
    var day = ('0' + d.getDate()).slice(-2);

    return year + '-' + month + '-' + day + ' ' + d.getHours() + ':' + d.getMinutes() + ':00';
})();

// To diff time between visit/registration/payment.
if (!getCookie('_first_now')) {
    if (now) {
        setCookie('_first_now', now, 2629800 * 13); // 2629800 = 1 month
        setCookie('_first_ua', encodeURIComponent(navigator.userAgent), 2629800 * 13);
        setCookie('_first_width', window.screen.width, 2629800 * 13);
        setCookie('_first_height', window.screen.height, 2629800 * 13);
        setCookie('_first_pixelDepth', window.screen.pixelDepth, 2629800 * 13);
        setCookie('_first_href', encodeURI(window.location.href).replace(/#.*/g, ''), 2629800 * 13);
        setCookie('_first_referer', encodeURI(document.referrer).replace(/#.*/g, ''), 2629800 * 13); // TODO What about the HTTPS redirect?
    }
}

// @see analytics.blade.php
// window.dataLayer = window.dataLayer || [];
// window.gtag = function() {
//     // console.info(arguments);
//     if (typeof dataLayer != 'undefined') {
//         dataLayer.push(arguments);
//     } else {
//         console.error('[google] dataLayer is undefined!', arguments);
//     }
// }

window.tooltip = function() {
    if (typeof $('[data-toggle="tooltip"]').tooltip != 'undefined') {
      return $('[data-toggle="tooltip"]').tooltip({
          html: true
      });
  }
}

$(function() {
    // setTimeout(tooltip, 5000);
    setInterval(tooltip, 2000);
});

// $(window).scroll(function() {
//     // console.error('scrollTop', $(document).scrollTop() > 20, $(document).scrollTop());
//     if ($(document).scrollTop() > 20) {
//         $('.fixed-top').removeClass('navbar-shrink');
//     } else {
//         $('.fixed-top').addClass('navbar-shrink');
//     }
// });

window.renderExternalIco = function() {
    // noopener noreferrer
    $('.external').each(function() {
        if ($(this).attr('target') !== '_blank') {
            if ($(this).hasClass('no-ico')) {
                $(this).attr('target', '_blank').attr('rel', 'noopener');
            } else {
                $(this).append('&nbsp;<i class="fas fa-external-link-alt fs-smaller" aria-hidden="true"></i>')
                    .attr('target', '_blank')
                    .attr('rel', 'noopener');
            }
        }
    });
    $('.external-pdf').each(function() {
        if ($(this).attr('target') !== '_blank') {
            $(this).prepend('<i class="fas fa-file-pdf fs-smaller text-danger ml-1" aria-hidden="true"></i>&nbsp;')
                .attr('target', '_blank')
                .attr('rel', 'noopener');
        }
    });
}
$(function() {
    renderExternalIco();
});

$(function() {
    $('span.btn-share').on('click', function() {
        var href = $(this).data('href');
        var w = 500;
        var h = 400;
        var left = (screen.width / 2) - (w / 2);
        var top = (screen.height / 2) - (h / 2);

        console.error('span.btn-share', href);

        window.open(href, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, top=' + top + ',left=' + left + ',width=' + w + ',height=' + h);
    });
});

$(function() {
    $('.form-date-with-slashes').keyup(function(e) {
        e.preventDefault();
        var pos = this.selectionStart;
        var keycode = e.which || e.keyCode;
        var val = $(this).val();
        if (keycode != 8) { // 8 = BACKSPACE
            val = val.replace(/^([0-9]{2})$/g, '$1/');
            val = val.replace(/^([0-9]+)\/([0-9]{2})$/g, '$1/$2/');
        }
        // console.error(pos, val, e.keyCode);
        $(this).val(val);

        if (!/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/g.test(val)) {
            $(this).addClass('is-invalid');
        } else {
            $(this).removeClass('is-invalid');
        }
    });
});

window.navByAnchor = function() {
  // Hash navigation
  let hash = window.location.hash;

  // Tab anchor navigation (nav-tabs)
  $('.nav-tabs .nav-link').click(function(e) {
    e.preventDefault();
    window.location.hash = this.hash;
  });
  if (hash) {
    let $el = $(`.nav-tabs .nav-link[href="${hash}"]`);
    if (typeof $el.tab != 'undefined') { // == 'function'
      $el.tab('show');
    }
    hash = hash.replace(/#\//, '#');
    $el = $(`.nav-tabs .nav-link[href="${hash}"]`);
    if (typeof $el.tab != 'undefined') {
      $el.tab('show');
    }
    // console.error(`.nav-tabs .nav-link[href="${hash}"]`, $(`.nav-tabs .nav-link[href="${hash}"]`));
  } else {
    $('.nav-tabs .nav-link:first').tab('show');
    // console.error(`.nav-tabs .nav-link:first`);
  }
}

$(function() {
  navByAnchor();
});

if ("onhashchange" in window) {
  window.onhashchange = function() {
    navByAnchor();
  }
}

window.hasClass = function(el, classname) {
    return el && el.className && el.className.split(' ').indexOf(classname) >= 0;
}

window.parentWithClass = function(el, classname) {
    if (hasClass(el, classname)) {
        return el;
    }

    return el && el.parentNode && parentWithClass(el.parentNode, classname);
}

// //cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.3/jquery.easing.min.js
// //cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js
// require('jquery.easing');

window.scrollTo = function(target) {
  setTimeout(function() {
    if ($(target).length) {
      $('html, body').stop().animate({
        scrollTop: $(target).offset().top - 75
      }, 1000, 'easeInOutExpo');
    } else {
      // console.error('scrollTo', target);
    }
  }, 300);
};

let pageScrollId = null;
let updatePageScroll = function() {
    let n = 0;
    $('.page-scroll').each(function() {
        if (!$(this).data('scrollable')) {
            $(this).bind('click', function(event) {
                var $anchor = $(this);
                var target = $anchor.attr('href');
                if ($anchor.data('href')) {
                    target = $anchor.data('href');
                }
                scrollTo(target);
                event.preventDefault();
            });
            $(this).data('scrollable', 1);
            n++;
        }
    });
    clearTimeout(pageScrollId);
    pageScrollId = setTimeout(updatePageScroll, 200);

    return true;
}

window.updatePageScroll = updatePageScroll;

$(function() {
    updatePageScroll();
});

window.Accordion = {
    $container: null,
    $links: [],
    init: function(target) {
        this.$container = $('#' + target);
        if (this.$container) {
            this.$links = this.$container.find('.accordion');
            this.$links.each(function() {
                $(this).on('click', function(e) {
                    Accordion.click($(this));
                });
            });
        }

        return true;
    },
    click: function($el) {
        this.hide();
        var href = $el.attr('href');
        var $target = $(href);
        if ($target.is(':visible')) {
            $target.hide();
        } else {
            $target.show();
        }
    },
    hide: function() {
        this.$links.each(function() {
            var href = $(this).attr('href');
            var $target = $(href);
            $($target).hide();
        });

        return true;
    }
};
$(function() {
    Accordion.init('accordion');
})

// module.exports = {
//   methods: Accordion.init
// };

// Message from parent window (iframe)
function quitQcm() {
  /*
  2020-09-15 Debug. Display swich portrait/landscape corrupted w iphone.
  return false;
  */
  if ($('body').hasClass('body-with-qcm')) {
    console.log('[qcm] quit', arguments);

    /*
    // TypeError: window.gtag is not a function
    window.gtag('event', 'qcm', {
        'event_category': 'close',
        'event_label': window.location.hash
    });
    */

    $('body').removeClass('body-with-qcm');

    if (arguments.length && arguments[0] == 'menu') {
      return false;
    }

    $('body').removeClass('registration');
    $('body').css('overflow', 'auto');
    $('.mcq-modal-histo').hide();

    let win = window.parent;
    let isNotParent = RegExp('^#/qcm/').test(window.location.hash);
    if (isNotParent || !win) {
      win = window;
    }
    let isHash = RegExp('^#/qcm/').test(win.location.hash);
    let isLaunch = !win.length;
    if (isHash) {
      if (window.history.length > 1) {
        window.history.go(-1);
      } else {
        window.location.href = '';
      }
    } else if (isLaunch) {
        window.opener = window;
        window.close();
    }
  } else {
      console.log('[qcm] already closed');
      // Just is case... @see /u/c/23-statistiques
      $('.mcq-modal-histo').hide();
      $('body').css('overflow', 'auto');
  }
}

window.openQcm = function() {

    console.log('[qcm] open', arguments);
    // window.scrollTo('body', 0);

    $('body').addClass('body-with-qcm');
    $('body').css('overflow', 'hidden');

    if (/free/.test(window.location.hash)) {
        $('body').addClass('registration');

        $('html, body').scrollTop(0);
    }

    // TypeError: window.gtag is not a function
    // window.gtag('event', 'qcm', {
    //     'event_category': 'open',
    //     'event_label': window.location.hash
    // });

    $('.body-with-qcm').find('.navbar').find('a[href]').click((e) => {
        // Navbar btns
        quitQcm('menu');
    });
    $('.body-with-qcm').find('.navbar').find('a[onclick]').on('click', (e) => {
        // Logout btn
        quitQcm('menu');
    });
}

// Show password
let showPwd = false;
window.switchPwd = function() {
    showPwd = !showPwd;
    if (showPwd) {
        $('#show-password').find('i').addClass('fa-eye-slash').removeClass('fa-eye');
        $('input[name=password]').attr('type', 'text');
        $('input[name=password_confirmation]').attr('type', 'text');
    } else {
        $('#show-password').find('i').addClass('fa-eye').removeClass('fa-eye-slash');
        $('input[name=password]').attr('type', 'password');
        $('input[name=password_confirmation]').attr('type', 'password');
    }
}

// https://developer.mozilla.org/fr/docs/Web/API/Window/postMessage
// window.parent.postMessage('qcmQuit',"*");
window.addEventListener("message", receiveMessage, false);

/**
 * @param MessageEvent e
 */
function receiveMessage(e) {
    if (e.data) {
        // console.error('receiveMessage', e);
    }
    if (e.data == 'qcmQuit') {
        quitQcm();
    }
}

// Right click on video
setInterval(function() {
    $('video').bind('contextmenu', function(e) {
        return false;
    });
}, 500);

// VUEJS
window.Vue = require('vue');
// @see https://interviewhelp.sharadhiinfotech.com/how-to-run-production-mode-in-vue-js-with-laravel/
Vue.config.devtools = false;
Vue.config.debug = false;
Vue.config.silent = true;

import VueRouter from 'vue-router';
Vue.use(VueRouter);

import 'video.js/dist/video-js.css';
import videoPlayer from 'vue-video-player';
Vue.use(videoPlayer);

import mcqsModal from './components/mcqs/modal.vue';
Vue.use(mcqsModal);

// import VueCkeditor from 'vue-ckeditor2'
// Vue.use(VueCkeditor);

// Rooter
// Ie.: /code/gratuit#/qcm/55/sfreePEweb1.xml
const routes = [{
        path: '/qcm/:productId/:filename',
        component: mcqsModal
    }, {
        path: '/qcm/:productId/:filename/:themes',
        component: mcqsModal
    }
    // ,{ path: '*', redirect: '/' },
    /*, {
      path :'*',
      component:mcqsModal
    }*/
    /*, {
      path: '/messages/:messageId',
      component: TODO
    }*/
];
// if (window.location.hash) {
if (window.namespace != 'public') {
  window.router = new VueRouter({
      // ensureHash: false,
      // mode: 'history', // To replace #/qcm/... by /qcm/...
      // hash: false,
      // hashbang: false,
      // history: true,
          // mode: 'html5',
        // linkActiveClass: 'active',
        // transitionOnLoad: true,
      routes: routes // short for `routes: routes`
  });
} else {
  window.router = new VueRouter({
    mode: 'history', // Add this to your router
    routes: []
  })
}
// }

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Init
if ($('#app-dv').length) {
    Vue.component('caroussel', require('./components/utils/Caroussel.vue').default);
    Vue.component('caroussel-slide', require('./components/utils/CarousselSlide.vue').default);
    Vue.component('rgpd', require('./components/utils/Rgpd.vue').default);
    Vue.component('addblock', require('./components/utils/AddBlock.vue').default);
}

// User-Agent
axios.get(`/xhr/ua?w=${window.screen.width}&h=${window.screen.height}&pd=${window.screen.pixelDepth}&href=${encodeURI(window.location.href).replace(/#.*/g, '')}&referer=${encodeURI(document.referrer).replace(/#.*/g, '')}`)
    .then(response => {
        // console.error(response);
    })
    .catch(error => {
        console.error(error);
    });
